import type { TvCategory } from '@setplex/tria-api'
import type { TvCategoryEx } from './index.h'

import { CategoryId, CategoryType } from './index.h'

export const hasChannels = (category: TvCategory) =>
  category.channelIds != null && category.channelIds.length > 0

export const isType = (type: CategoryType) => (category: TvCategoryEx) =>
  category.type === type

export const isNotType = (type: CategoryType) => (category: TvCategoryEx) =>
  category.type !== type

export const toType =
  (type: CategoryType) =>
  (category: TvCategory): TvCategoryEx => ({
    ...category,
    channelIds: category.channelIds ?? [],
    type,
  })

export const toFavoriteType = toType(CategoryType.Favorite)
export const toAllType = toType(CategoryType.All)
export const toFeaturedType = toType(CategoryType.Featured)
export const toRegularType = toType(CategoryType.Regular)

const categoryIdByType: Record<CategoryType, CategoryId> = {
  [CategoryType.Favorite]: CategoryId.Favorite,
  [CategoryType.All]: CategoryId.All,
  [CategoryType.Featured]: CategoryId.Featured,
  [CategoryType.Regular]: CategoryId.Regular,
}

export const idByType = (type: CategoryType) => categoryIdByType[type]
